import { useLocation } from "react-router-dom";

export function useDemo() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const isDemo = query.get("demo") === "true";

  return { isDemo };
}
